import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/Services/authentication.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { SharedService } from 'src/app/Services/shared.service';


@Component({
  selector: 'ze-update-password-view',
  templateUrl: './update-password-view.component.html',
  styleUrls: ['./update-password-view.component.scss']
})
export class UpdatePasswordViewComponent implements OnInit {

  user: string = "";
  loading = false;
  error = '';
  returnUrl: string;
  public form: FormGroup;
  public passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,}$/;

  constructor(private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private _sharedService: SharedService,
    private route: ActivatedRoute,
    private router: Router,
    private notifyService: NotifyService) {
    let currentUser1 = JSON.parse(localStorage.getItem("currentUser")).token;
    this.user = this.parseJwt(JSON.stringify(currentUser1)).sub;
    this.formInit();
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/project';
  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  }

  private formInit() {
    this.form = this.formBuilder.group({
      username: [this.user, [Validators.required]],
      oldPassword: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
      newPassword: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
      confirmNewPassword: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
    }, { validator: this.checkingPasswords });
  }

  public checkingPasswords(formGroup: FormGroup) {
    if (
      formGroup.controls.newPassword.value &&
      formGroup.controls.oldPassword.value &&
      formGroup.controls.newPassword.value.length >= 8 &&
      formGroup.controls.oldPassword.value.length >= 8
    ) {
      if (
        formGroup.controls.newPassword.value &&
        formGroup.controls.confirmNewPassword.value &&
        formGroup.controls.newPassword.value.length >= 8 &&
        formGroup.controls.newPassword.value !== formGroup.controls.oldPassword.value
      ) {
        return formGroup.controls.newPassword.value === formGroup.controls.confirmNewPassword.value ? false : { "notMatched": true }
      }
      return formGroup.controls.newPassword.value === formGroup.controls.oldPassword.value ? { "samePassword": true } : false;
    }    
    return false;
  }

  checkPasswordValidations(): boolean {
    return (!this.form.controls.newPassword.pristine && this.form.controls.newPassword.errors && this.form.controls.newPassword.errors.pattern) 
    || (!this.form.controls.confirmNewPassword.pristine && this.form.controls.confirmNewPassword.errors && this.form.controls.confirmNewPassword.errors.pattern)
    || (!this.form.controls.oldPassword.pristine && this.form.controls.oldPassword.errors && this.form.controls.oldPassword.errors.pattern);
  }

  changePassword(): void {
    this._sharedService.loaderHide.emit(true);
    this.loading = true;
    this.authenticationService.changePassword(this.form.controls.username.value, this.form.controls.oldPassword.value, this.form.controls.newPassword.value).subscribe(
      data => {
        this.error = '';
        this.loading = false;
        this._sharedService.loaderHide.emit(false);
        this.notifyService.notify('success', 'Success', "Password Changed Successfully");
      },
      error => {
        this.error = error == 'Invalid Credentials' ? 'Incorrect current password. Please try again' : error;
        this.loading = false;
        this._sharedService.loaderHide.emit(false);
        this.notifyService.notify('error', 'Failed', this.error);
      }
    );

  }

  cancel(): void {
    this.router.navigateByUrl(this.returnUrl);
  }

}
